// src/components/Navbar/Logo.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo_archivo_deportivo from '../../assets/images/icono_archivodep.png';

const Logo = () => (
  <Link to="/" className="flex items-center">
    <img 
      src={logo_archivo_deportivo} 
      alt="Archivo Deportivo" 
      className="h-14" 
    />
  </Link>
);

export default Logo;